var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFilePdf = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#CC1D1D",
  d: "M3.996 4a2 2 0 0 1 2-2h8l6 6v12a2 2 0 0 1-2 2h-12a2 2 0 0 1-2-2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m13.996 2 6 6h-4a2 2 0 0 1-2-2z",
  opacity: 0.25
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14.046 18v-3.273h2.234v.642h-1.443v.671h1.3v.644h-1.3V18zM11.967 18h-1.21v-3.273h1.208q.5 0 .862.196.363.195.56.563.196.366.196.875 0 .511-.197.88-.195.367-.558.564-.363.195-.861.195m-.419-.675h.389q.274 0 .465-.092a.6.6 0 0 0 .289-.306q.099-.212.099-.566 0-.353-.1-.562a.6.6 0 0 0-.292-.304 1.1 1.1 0 0 0-.473-.094h-.377zM7.82 18v-3.273h1.352q.368 0 .635.143.269.143.414.398t.145.592q0 .338-.148.593a1 1 0 0 1-.42.391q-.275.14-.65.14h-.834v-.624h.687q.18 0 .3-.062a.43.43 0 0 0 .183-.175.54.54 0 0 0 .062-.263.5.5 0 0 0-.062-.262.4.4 0 0 0-.184-.173.7.7 0 0 0-.299-.06h-.39V18z"
})));
export default SvgFilePdf;